<template>
  <div id="app">
    <transition name="slide-fade">
      <router-view class="page" />
    </transition>
  </div>
</template>
<script>
export default {
  created: function () {
    //在页面加载时读取localStorage里的状态信息
    localStorage.getItem("userMsg") &&
      this.$store.replaceState(
        Object.assign(
          this.$store.state,
          JSON.parse(localStorage.getItem("userMsg"))
        )
      );

    //在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener("beforeunload", () => {
      localStorage.setItem("userMsg", JSON.stringify(this.$store.state));
    });
  },
};
</script>
<style>
* {
  padding: 0;
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  text-align: center;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  will-change: transform;
  transition: all 500ms;
  position: absolute;
}
.slide-fade-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-fade-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.page {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  margin: 0 auto;
}
</style>
